export default __webpack_public_path__ + "static/media/Westermarck Crossbow.43e2dbcf.jpg";